import { Component, OnInit,Input,Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';


@Component({
  selector: 'app-personal-details',
  templateUrl: './personal-details.component.html',
  styleUrls: ['./personal-details.component.scss']
})
export class PersonalDetailsComponent implements OnInit {
  infoModalIsUkPostcodeVisible = false;
  infoModalIsDOBVisible = false;

  @Input('parentForm') public personalDetailForm: UntypedFormGroup;

  @Output() SelectIsUkResident: EventEmitter<any> = new EventEmitter();
  postcode: string;
  genderSelected: string = null;
  maritalSelected: string = null;
  postCodeDefault:string=null;
  contentData: object;
  annuitantConfiguration: object;

  genderValues: any;

  maritalValues: any;

  radioButtonIsUKAddress: any;

  constructor(private fb: UntypedFormBuilder, private router: Router, private location: Location,
              private route: ActivatedRoute)  { 
              this.contentData = this.route.snapshot.data.contentData;
              this.annuitantConfiguration = this.route.snapshot.data.annuitantconfiguration;
              } 

  ngOnInit() {
    this.genderValues = this.annuitantConfiguration['personalDetail']['genderValues'];
    this.maritalValues = this.annuitantConfiguration['personalDetail']['maritalValues'];
    this.radioButtonIsUKAddress = this.annuitantConfiguration['personalDetail']['radioButtonIsUKAddress'];
  }

  genderChange(optionselected: any) {
    this.genderSelected = optionselected;
  }

  toggleInfoPostCodeOpen() {
    this.infoModalIsUkPostcodeVisible = ! this.infoModalIsUkPostcodeVisible;
  }

  toggleInfoPostCodeClose() {
    this.infoModalIsUkPostcodeVisible = ! this.infoModalIsUkPostcodeVisible;
  }
  toggleInfoDOBOpen() {
    this.infoModalIsDOBVisible = ! this.infoModalIsDOBVisible;
  }

  toggleInfoDOBClose() {
    this.infoModalIsDOBVisible = ! this.infoModalIsDOBVisible;
  }
  toggleContainer = (data) => {
    if (data.Name === 'Yes') {
      this.personalDetailForm.get('ukaddressIndicator').setValue('Y');
      this.SelectIsUkResident.emit('Y');
    } else {
      this.personalDetailForm.get('ukaddressIndicator').setValue('N');
      this.SelectIsUkResident.emit('N');
    }

  }
}
